/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export const getItemBounds = (node: HTMLElement | null) => {
  if (!node) {
    return;
  }

  const xOffset = window.pageXOffset;
  const yOffset = window.pageYOffset;

  const boundingClientRect = node.getBoundingClientRect();
  const top = boundingClientRect.top + yOffset;
  const right = boundingClientRect.right;
  const bottom = boundingClientRect.bottom;
  const left = boundingClientRect.left + xOffset;
  const width = boundingClientRect.width;
  const height = boundingClientRect?.height;

  return {
    top: Math.round(top),
    left: Math.round(left),
    right: Math.round(right),
    bottom: Math.round(bottom),
    width: Math.round(width),
    height: Math.round(height),
  };
};
